import { useI18n } from '@/hooks/useI18n';
import { useTheme } from '@/hooks/useTheme';
import type { TranslationKey } from '@/i18n';
import type { ThemePreference } from '@/types';

const options: { value: ThemePreference; glyph: string; labelKey: TranslationKey }[] = [
  { value: 'system', glyph: '◐', labelKey: 'theme.system' },
  { value: 'light', glyph: '☼', labelKey: 'theme.light' },
  { value: 'dark', glyph: '●', labelKey: 'theme.dark' },
];

export const ThemeSwitcher = () => {
  const { preference, setPreference } = useTheme();
  const { t } = useI18n();

  return (
    <div className="theme-switch" role="group" aria-label={t('a11y.theme')}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          title={t(option.labelKey)}
          aria-label={t(option.labelKey)}
          aria-pressed={preference === option.value}
          onClick={() => setPreference(option.value)}
        >
          {option.glyph}
        </button>
      ))}
    </div>
  );
};
